/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable, inject, linkedSignal } from '@angular/core';
import { Store } from '@ngrx/store';
import { mime_type, WatchVideoConditionalProps, Resource } from '../types';
import { RESOURCE_PAGE_ACTIONS } from '../actions';
import { RESOURCE_SIGNAL_STORE } from '../signals';
import { generateResourceCards } from '../utils/resource-card.util';

@Injectable()
export class ResourceFacadeService {
  private readonly _resourceSignalStore = inject(RESOURCE_SIGNAL_STORE);
  private readonly _store = inject(Store);

  /**
   * @RESCOURCE SIGNAL
   * @RESOURCE SELECTOR
   * */
  $resourceObj = linkedSignal({
    computation: (data: Resource[]) => {
      if (!data) {
        return [];
      }
      return generateResourceCards(data);
    },
    source: this._resourceSignalStore.$resources,
  });

  /**
   * @RESCOURCE ACTIONS
   * */
  downloadResource(
    resourceId: string,
    mime_type: mime_type,
    conditionalProps: WatchVideoConditionalProps | null,
  ) {
    this._store.dispatch(
      RESOURCE_PAGE_ACTIONS.downloadResource({
        conditionalProps,
        mime_type,
        uuid: resourceId,
      }),
    );
  }
}
